import type { RouteObject } from 'react-router'
import { Navigate } from 'react-router'
import { MainLayout } from '@/components/layout/MainLayout/index.ts'
import { LegacyVaultDetailRedirect } from '@/app/router/LegacyRedirects.tsx'
import { ProtectedRoute } from '@/components/layout/ProtectedRoute/index.ts'
import { HomePage } from '@/features/home/index.ts'
import { DashboardPage } from '@/features/dashboard/index.ts'
import { SettingsPage } from '@/features/settings/index.ts'
import { ProfilePage } from '@/features/profile/index.ts'
import {
  BenefactorOnboardPage,
  BeneficiaryOnboardPage,
} from '@/features/onboarding/index.ts'
import { CreateVaultPage, VaultDetailPage } from '@/features/vault/index.ts'
import { ActivityLogPage } from '@/features/activity/index.ts'
import { AdminPage } from '@/features/admin/index.ts'
import { TestDashboardPage } from '@/features/test-runner/index.ts'
import { StatusPage } from '@/features/status/index.ts'

export const routes: RouteObject[] = [
  {
    path: '/',
    element: <MainLayout />,
    children: [
      { index: true, element: <HomePage /> },
      // Legacy / mistaken URL: send guests home (E2E + bookmarks).
      { path: 'admin', element: <Navigate to="/" replace /> },
      { path: 'admlgn', element: <AdminPage /> },
      { path: 'status', element: <StatusPage /> },
      { path: 'test-runner', element: <TestDashboardPage /> },
      {
        element: <ProtectedRoute />,
        children: [
          { path: 'benefactor', element: <BenefactorOnboardPage /> },
          { path: 'beneficiary', element: <BeneficiaryOnboardPage /> },
          { path: 'dashboard', element: <DashboardPage /> },
          { path: 'dashboard/create-vault', element: <CreateVaultPage /> },
          {
            path: 'dashboard/vaults/:id',
            element: <LegacyVaultDetailRedirect />,
          },
          {
            path: 'dashboard/subscribe',
            element: <Navigate to="/benefactor" replace />,
          },
          { path: 'dashboard/vault/:id', element: <VaultDetailPage /> },
          { path: 'dashboard/activity', element: <ActivityLogPage /> },
          { path: 'profile', element: <ProfilePage /> },
          { path: 'settings', element: <SettingsPage /> },
        ],
      },
    ],
  },
]
